import NewForm from 'components/NewForm';
import ThreeStateCheckbox from 'components/ThreeStateCheckbox';
import React, { useEffect, useState } from 'react';
import permissionService from 'services/permission.service';
import "./../style-profile-page.scss";
import { useTranslation } from 'react-i18next';
import Icon from 'components/Icon';

interface IPermission{
  id: number | string;
  name:string;
  alias:string;
  children?:IPermission[];
  checked?:undefined | boolean;
  variants?:IPermission[];
  t:{
    key:string,
    data?:any,
  }
}

export default function Permissions(props?:any){
  // const [ Model, SetModel ] = useSessionStorageTempPage("permissions_selected",(props && props.model && props.model.permissions)?props.model.permissions:[]);IPermission[]
  const [ Model, SetModel ] = useState((props && props.model && props.model.permissions)?props.model.permissions.map((a:any)=>a.id):[])
  const [ opened, setOpened ] = useState<string>("");
  
  // const [ list, setList ] = useSessionStorageTempPage<IPermission[]>("permissions",[]);
  const [list, setList] = useState<IPermission[]>([])

  const { t } = useTranslation()

  function updateList(alias:string, value:undefined | boolean){
    function getItem(item:IPermission, alias:string, value:undefined | boolean):IPermission{
      if(item.alias === alias){
        item.checked = value;
        if(item.children && item.children.length > 0){
          item.children = modifyChildren(item.children,value)
        }
      } else {
        if(item.children && item.children.length > 0){
          let quantity = [0,0,0];
          item.children = item.children.map(item2=>{
            item2 = getItem(item2,alias,value);

            if(item2.checked === true) quantity[0]++;
            else if(item2.checked === false) quantity[1]++;
            else quantity[2]++;

            return item2;
          });

          if(quantity[1] === 0 && quantity[2] === 0){
            item.checked = true;
          } else if(quantity[0] === 0 && quantity[2] === 0){
            item.checked = false;
          } else {
            item.checked = undefined;
          }
        }
      }
      return item;
    }
    function modifyChildren(children:IPermission[],value:undefined | boolean):IPermission[]{
      return children.map((it)=>{
        it.checked = value;
        if(it.children){
          it.children = modifyChildren(it.children,value);
        }
        return it;
      })
    }
    function getId(list:IPermission[]):Array<number|string> {
      let ids:Array<number|string> = [];
      for(let i=0;i<list.length; i++){
        let item = list[i];
        if(item.checked !== false){
          ids.push(item.id);
        }
        if(item.children && item.children.length > 0){
          ids = [...ids, ...getId(item.children)]
        }
      }
      return ids;
    }

    let aux_list = [...list].map(item=>{
      item = getItem(item,alias,value);
      return item;
    })
    setList([...aux_list]);
    let l = getId(aux_list);
    SetModel(l);
    props.setModel((old:any)=>({
      ...old,permissions:l
    }));
  }

  function renderList(list:IPermission[], tabcount:number){
    function isOpened(alias:string):boolean{
      return opened.indexOf(alias) !== -1;
    }
    return list.map((item,key)=>{
      let opened = isOpened(item.alias);
      return (
        <div className="permission-item" key={key}>
          <div className="permission-item-click" onClick={(e)=>{
            let t:any = e.target;
            if(t.tagName !== "INPUT"){
              if(item.children && item.children.length > 0)setOpened((old)=>{
                if(item.alias === old || old.indexOf(item.alias) !== -1){
                  if (item.alias.indexOf(".") !== -1) {
                    let aux = item.alias.split(".");
                    let aux_r = "";
                    for (let i = 0; i < aux.length-1; i++) {
                      const s = aux[i];
                      if(i>0){
                        aux_r += ".";
                      }
                      aux_r += s;
                    }
                    return aux_r;
                  }
                  return "";
                };
                return item.alias;
              });
            }
          }}>
            <div className={opened?"permission-item-opened":""}>
              {item.children && item.children.length > 0?<Icon name="angle-right"/>:""}
              <div className="permission-item-name">{t("permission:"+item.t.key,item.t.data)}</div>
            </div>
            <ThreeStateCheckbox onChange={(value)=>{
              updateList(item.alias, value);
            }} checked={item.checked}/>
            {/* <div>{item.alias}</div> */}
          </div>
          <div className={"permission-item-children-area"+(opened?" permission-item-children-area-opened":"")}>
            {item.children && item.children.length > 0?(
              <div className="permission-item-children">
                {renderList(item.children,tabcount+1)}
              </div>
            ):""}
          </div>
        </div>
      );
    });
  }

  // Get list of permissions
  useEffect(()=>{
    function getListFull(list:IPermission[]){
      function getPermissionsSelected(p:IPermission, permissions:Array<number | string>):boolean | undefined{

        if(p.children){
          let quantity = [0,0,0];
          p.children = p.children.map(p2=>{
            p2 = {...p2};
            p2.checked = getPermissionsSelected(p2,permissions);
  
            if(p2.checked === true) quantity[0]++;
            else if(p2.checked === false) quantity[1]++;
            else quantity[2]++;
  
            return p2;
          });
  
          if(quantity[1] === 0 && quantity[2] === 0){
            return true;
          } else if(quantity[0] === 0 && quantity[2] === 0){
            return false;
          } else {
            return undefined;
          }
        } else {
          return permissions.indexOf(p.id) !== -1; 
        }
      }
      if(list.length>0){
        return [...list].map(item => {
          item = {...item};
          item.checked = getPermissionsSelected(item,Model);
          
          return item;
        })
      }
      return [...list];
    }

    function formatList(list:IPermission[]){
      let aux: IPermission[] = [];
      list.forEach((item)=>{
        if(item.children && item.children.length > 0){
          item.children = formatList(item.children);
        }
        if(item.variants){
          item.variants.forEach((variant,key)=>{
            aux.push({...variant, id:`${item.id}.${key}`});
          })
        } else {
          aux.push(item);
        }
      });
      return aux;
    }
    
    if(list.length === 0){
      permissionService.get<IPermission[]>({params:{
        embed:"children"
      }}).then((data)=>{
        let aux = formatList(data);
        setList(getListFull(aux));
      })
    }
  },[list, setList, Model]);

  return (
    <NewForm title={t("title:profile:permissions")}>
      <div className="permission-area">
        {renderList(list,0)}
      </div>
    </NewForm>
  );
}